var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "col-3 col-sm-3" }, [
    _c(
      "div",
      { staticClass: "list-group" },
      [
        _c(
          "router-link",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: _vm.trans("user.basic"),
                expression: "trans('user.basic')",
              },
            ],
            class: [_vm.menu === "basic" ? "active" : "", "list-group-item"],
            attrs: { to: `/account/users/general-partners/${_vm.id}/basic` },
          },
          [
            _c("span", { staticClass: "hidden-sm-up" }, [
              _c("i", { staticClass: "fas fa-user" }),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "hidden-xs-down" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.trans("user.basic")) +
                  "\n            "
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "router-link",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: "Notes",
                expression: "'Notes'",
              },
            ],
            class: [_vm.menu === "notes" ? "active" : "", "list-group-item"],
            attrs: { to: `/account/user/${_vm.id}/notes` },
          },
          [
            _c("span", { staticClass: "hidden-sm-up" }, [
              _c("i", { staticClass: "fas fa-file" }),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "hidden-xs-down" }, [
              _vm._v("\n               Notes\n            "),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "router-link",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: "Contact Pipeline",
                expression: "'Contact Pipeline'",
              },
            ],
            class: [
              _vm.menu === "emails-pipeline" ? "active" : "",
              "list-group-item",
            ],
            attrs: { to: `/account/user/${_vm.id}/emails-pipeline` },
          },
          [
            _c("span", { staticClass: "hidden-sm-up" }, [
              _c("i", { staticClass: "fas fa-mailbox" }),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "hidden-xs-down" }, [
              _vm._v("\n               History\n            "),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "router-link",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: "Questionnaire",
                expression: "'Questionnaire'",
              },
            ],
            class: [
              _vm.menu === "questionnaire" ? "active" : "",
              "list-group-item",
            ],
            attrs: { to: `/account/user/${_vm.id}/questionnaire` },
          },
          [
            _c("span", { staticClass: "hidden-sm-up" }, [
              _c("i", { staticClass: "fas fa-question" }),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "hidden-xs-down" }, [
              _vm._v("\n               Questionnaire\n            "),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "router-link",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: "Investor List",
                expression: "'Investor List'",
              },
            ],
            class: [
              _vm.menu === "investor-list" ? "active" : "",
              "list-group-item",
            ],
            attrs: { to: `/account/user/${_vm.id}/investor-list` },
          },
          [
            _c("span", { staticClass: "hidden-sm-up" }, [
              _c("i", { staticClass: "fas fa-users" }),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "hidden-xs-down" }, [
              _vm._v("\n               Investor List\n            "),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "router-link",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: "Documents",
                expression: "'Documents'",
              },
            ],
            class: [
              _vm.menu === "documents" ? "active" : "",
              "list-group-item",
            ],
            attrs: { to: `/account/user/${_vm.id}/documents` },
          },
          [
            _c("span", { staticClass: "hidden-sm-up" }, [
              _c("i", { staticClass: "fas fa-file" }),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "hidden-xs-down" }, [
              _vm._v("\n               Documents\n            "),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "router-link",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: "Investors",
                expression: "'Investors'",
              },
            ],
            class: [
              _vm.menu === "investors" ? "active" : "",
              "list-group-item",
            ],
            attrs: { to: `/account/user/${_vm.id}/investors` },
          },
          [
            _c("span", { staticClass: "hidden-sm-up" }, [
              _c("i", { staticClass: "fas fa-users" }),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "hidden-xs-down" }, [
              _vm._v("\n               Assigned Investors\n            "),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "router-link",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: "Weightings",
                expression: "'Weightings'",
              },
            ],
            class: [
              _vm.menu === "weightings" ? "active" : "",
              "list-group-item",
            ],
            attrs: {
              to: `/account/users/general-partners/${_vm.id}/weightings`,
            },
          },
          [
            _c("span", { staticClass: "hidden-sm-up" }, [
              _c("i", { staticClass: "fas fa-scale-unbalanced-flip" }),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "hidden-xs-down" }, [
              _vm._v("\n               Weightings\n            "),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "router-link",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: "Sales Pipeline",
                expression: "'Sales Pipeline'",
              },
            ],
            class: [
              _vm.menu === "sales-pipeline" ? "active" : "",
              "list-group-item",
            ],
            attrs: {
              to: `/account/users/general-partners/${_vm.id}/sales-pipeline`,
            },
          },
          [
            _c("span", { staticClass: "hidden-sm-up" }, [
              _c("i", { staticClass: "fas fa-scale-unbalanced-flip" }),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "hidden-xs-down" }, [
              _vm._v("\n               Sales History\n            "),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "router-link",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: "Login Log",
                expression: "'Login Log'",
              },
            ],
            class: [
              _vm.menu === "login-log" ? "active" : "",
              "list-group-item",
            ],
            attrs: {
              to: `/account/users/general-partners/${_vm.id}/login-log`,
            },
          },
          [
            _c("span", { staticClass: "hidden-sm-up" }, [
              _c("i", { staticClass: "fas fa-scale-unbalanced-flip" }),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "hidden-xs-down" }, [
              _vm._v("\n              Login Log\n            "),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "router-link",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: "Presentation",
                expression: "'Presentation'",
              },
            ],
            class: [
              _vm.menu === "presentation" ? "active" : "",
              "list-group-item",
            ],
            attrs: { to: "/ps/" + _vm.id + "/pdf", target: "_blank" },
          },
          [
            _c("span", { staticClass: "hidden-sm-up" }, [
              _c("i", { staticClass: "fas fa-scale-unbalanced-flip" }),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "hidden-xs-down" }, [
              _vm._v("\n              Presentation\n            "),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "router-link",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: "Presentation",
                expression: "'Presentation'",
              },
            ],
            class: [
              _vm.menu === "presentation" ? "active" : "",
              "list-group-item",
            ],
            attrs: { to: "/ps2/" + _vm.id + "/pdf", target: "_blank" },
          },
          [
            _c("span", { staticClass: "hidden-sm-up" }, [
              _c("i", { staticClass: "fas fa-scale-unbalanced-flip" }),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "hidden-xs-down" }, [
              _vm._v("\n              Presentation V2\n            "),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "router-link",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: "Fact Sheet",
                expression: "'Fact Sheet'",
              },
            ],
            class: [
              _vm.menu === "fact-sheet" ? "active" : "",
              "list-group-item",
            ],
            attrs: {
              to: "/account/users/general-partners/" + _vm.id + "/fact-sheet",
              target: "_blank",
            },
          },
          [
            _c("span", { staticClass: "hidden-sm-up" }, [
              _c("i", { staticClass: "fas fa-scale-unbalanced-flip" }),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "hidden-xs-down" }, [
              _vm._v("\n              Fact Sheet\n            "),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "router-link",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: "Presentation",
                expression: "'Presentation'",
              },
            ],
            class: [
              _vm.menu === "presentation" ? "active" : "",
              "list-group-item",
            ],
            attrs: {
              to:
                "/account/users/general-partners/" + _vm.id + "/fact-sheet-v2",
              target: "_blank",
            },
          },
          [
            _c("span", { staticClass: "hidden-sm-up" }, [
              _c("i", { staticClass: "fas fa-scale-unbalanced-flip" }),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "hidden-xs-down" }, [
              _vm._v("\n               Fact Sheet V2\n            "),
            ]),
          ]
        ),
        _vm._v(" "),
        _vm.id != _vm.getAuthUser("id")
          ? _c(
              "router-link",
              {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: _vm.trans("user.reset_password"),
                    expression: "trans('user.reset_password')",
                  },
                ],
                class: [
                  _vm.menu === "password" ? "active" : "",
                  "list-group-item",
                ],
                attrs: {
                  to: `/account/users/general-partners/${_vm.id}/password`,
                },
              },
              [
                _c("span", { staticClass: "hidden-sm-up" }, [
                  _c("i", { staticClass: "fas fa-key" }),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "hidden-xs-down" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.trans("user.reset_password")) +
                      "\n            "
                  ),
                ]),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }